<div class="rd-flex flex-row" aria-label="Multiple select buttons">
  <button
    *ngFor="let button of buttons; let i = index"
    type="button"
    class="btn btn-outline-primary mr-3 mb-3"
    (click)="writeValue(button.value)"
    [class.active]="isSelected(button.value)"
    [attr.yp-e2e-id]="'e2e-multiple-select-option-'+(button?.e2eId || i)"
  >
    {{button.label}}
  </button>
</div>

